import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore, AuthState, useAuthenticated } from '@stores/auth';

const AuthRoute: React.FC = () => {
  const { authState, userData } = useAuthStore();
  const isAuthenticated = useAuthenticated();
  const location = useLocation();

  if (authState > AuthState.FETCHING_USER) {
    if (!isAuthenticated && location.pathname !== '/') return <Navigate replace to="/" />;
    if (userData?.mainChannel === null && location.pathname !== '/terms')
      return <Navigate replace to="/terms" />;

    return <Outlet />;
  }

  if (authState === AuthState.NOT_SIGNED_IN) {
    return <Navigate replace to="/login" />;
  }

  return null;
};

export default AuthRoute;
